import React, { PureComponent } from 'react';

interface Props {
  size: number;
}

class Addigy extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        {...otherProps}
      >
        <path d="M19.8184441,17.6221126 L11.4301283,6.59321295 L15.9777035,5.1724681 L21.6351625,12.6108871 L19.8184441,17.6221126 Z M0,21.5 L22.7678422,21.5 L24,12.4746973 L16.762879,3 L5.13170763,4.03823662 L17.0324704,19.6853452 L15.1215181,18.0992496 L9.65894837,18.0992496 L12.1252974,15.6124207 L10.0404325,13.8819913 L0,21.5 Z" />
      </svg>
    );
  }
}

export default Addigy;
